export enum ProtocolDictionary {
  Achi = 1,
  Icd10 = 2,
  Icpc2 = 3,
  Drug = 4,
  Laboratory = 5,
}

export const PROTOCOL_DICTIONARY_LABEL: Record<ProtocolDictionary, string> = {
  [ProtocolDictionary.Achi]: 'ACHI',
  [ProtocolDictionary.Icd10]: 'ICD-10',
  [ProtocolDictionary.Icpc2]: 'ICPC-2',
  [ProtocolDictionary.Drug]: 'Drug',
  [ProtocolDictionary.Laboratory]: 'Laboratory',
};

export interface CodeValidationResult {
  code: string;
  dictionary: ProtocolDictionary;
  found: boolean;
  nameUa?: string | null;
  nameEn?: string | null;
}

export interface ProtocolValidationResult {
  valid: boolean;
  codes: CodeValidationResult[];
  errors: string[];
}
